
















import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'input-name2',
     props: {
        value: String,
        placeholder: String
    },
    data() {
        return {
            style: style,
            showInput:false,
            label: this.value
        }
    },
    methods: {
        apply() {
            this.showInput = false;
            
            this.label = !this.value ? 'Введите название' : this.value;
            
            this.$emit('blur');
        },
        showAndFocusInput(): void {
            this.showInput = true;

            if(this.value === 'Введите название') {
                this.model = ''
            }

            this.$nextTick(() => {
                const input = this.$refs.input as Vue

                if(input instanceof HTMLElement) {
                    input.focus()
                }
            })
        },
    },
    computed: {
        model: {
            get(): string {
                return this.value
            },
            set(value: string): void {
                this.$emit('input', value);
            }
        }
    },
    watch: {
        value() {
            this.label = this.value === 'Введите название' ? '' : this.value;
        }
    }
})
